/**
 * drawer-content.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    margin: `${theme.spacing(3)} ${theme.spacing(2)}`,
    [theme.breakpoints.up('sm_md')]: {
      margin: `${theme.spacing(0)} ${theme.spacing(6)} ${theme.spacing(3)}`,
    },
    overflowY: props => props.overflowY ?? 'unset',
    '.drawer-section &': {
      margin: `${theme.spacing(0)} ${theme.spacing(3)} ${theme.spacing(3)}`,
      [theme.size.menuDrawer.mediaRuleMobileContent]: {
        margin: `${theme.spacing(3)} ${theme.spacing(2)}`
      },
    }
  }
}));

export default function DrawerContent(props) {
  const { children, overflowY, ...rest } = props;
  const classes = useStyles({ overflowY });

  return (
    <>
      <div 
        className={classes.root} 
        data-testid="drawer-content"
        {...rest}
      >
        {children}
      </div>
    </>
  );
}

